module.exports = __webpack_public_path__ + "static/media/3wise_logo_nologo.933b0b72.png";